module.exports = __webpack_public_path__ + "static/basic-flow_1-d5b5e1c8c133721eb05a44b13fa40152.png";